import React, { FC, useContext } from "react"
import styled from "styled-components"

import { PricingTablePlanFragmentFragment } from "@graphqlTypes"

import ContentfulLpContext from "@context/ContentfulLpContext/ContentfulLpContext"

import ToggleWithText, { TOGGLE_SIZES } from "@components/ToggleWithText/ToggleWithText"

import PricingPlanCard from "./PricingPlanCard/PricingPlanCard"

const PricingTableHeaderHEADER = styled.header`
  h2 {
    text-wrap: balance;
    flex: 0 0 100%;
  }

  .Button {
    width: 100%;
  }

  .toggle-wrapper {
    position: relative;
    width: fit-content;
    height: fit-content;
  }

  .ToggleWithText {
    margin-bottom: 0;
  }

  .annual-discount-badge {
    background: var(--color--green-100);
    border-radius: var(--border-radius--XS);
    border: 1px solid var(--color--green-300);
    box-shadow: 0px 0px 4px 0px rgba(var(--color--green-accent-rgb), 0.50);
    display: block;
    opacity: 0;
    padding: 0 6px;
    position: absolute;
    right: 0;
    top: 50%;
    transition: opacity 0.5s, translate 0.3s;
    translate: calc(100% + var(--spacing--XS) / 2) -50%;

    &.is-visible {
      opacity: 1;
      translate: calc(100% + var(--spacing--XS)) -50%;
    }
  }

  .header-content {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing--S);
    align-items: space-between;
  }
  
  .plans {
    gap: var(--spacing--base-0-75);
    align-items: stretch;

    .plan {
      flex: 0 0 calc(33.3333% - var(--spacing--base-0-75) * 2 / 3);
      padding-bottom: 0;
    }
  }
`

const PricingTableHeader: FC<{
  plans: Array<PricingTablePlanFragmentFragment | null>
  titleHtml: string
}> = ({
  plans,
  titleHtml,
}) => {
    const {
      isAnnualDiscountApplied,
      isSalesPage,
      setIsAnnualDiscountApplied
    } = useContext(ContentfulLpContext)

    return (
      <>
        <div className="container">
          <PricingTableHeaderHEADER className="grid padding-bottom--L">
            <div className="header-content column column--1-4-L column--1-5-XL">
              <h2 id="compare-plans-and-features" dangerouslySetInnerHTML={{ __html: titleHtml }} />
              <div className="toggle-wrapper">
                <ToggleWithText
                  options={[
                    {
                      title: "Monthly",
                      isActive: !isAnnualDiscountApplied,
                      onClick: () => setIsAnnualDiscountApplied && setIsAnnualDiscountApplied(false),
                    },
                    {
                      title: "Annual",
                      isActive: isAnnualDiscountApplied,
                      onClick: () => setIsAnnualDiscountApplied && setIsAnnualDiscountApplied(true),
                    },
                  ]}
                  size={TOGGLE_SIZES.M}
                />
                {/* <span className={`annual-discount-badge type--text-medium-XS${isAnnualDiscountApplied ? " is-visible" : ""}`}>
                  -{annualDiscountPercentage}%
                </span> */}
              </div>
            </div>
            <div className="plans flex column column--4-13-L column--5-13-XL">
              {plans.map((plan, i) => !plan ? null : (
                <PricingPlanCard
                  key={plan.name}
                  hideButton={isSalesPage}
                  plan={plan}
                  usePrimaryButton={i > 0}
                />
              ))}
            </div>
          </PricingTableHeaderHEADER>
        </div>
      </>
    )
  }

export default PricingTableHeader

